import { Button, Typography } from "antd";
import Dragger from "antd/es/upload/Dragger";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { ReactEditor, useSlateStatic } from "slate-react";
import { updateStickers } from "../../../api/Update";
import CustomEditor from "../CustomEditorConfig";

const { Text } = Typography;
const DisplayImg = (props) => {
  const { onDelete } = props;
  const [showDelete, setShowDelete] = useState(false);
  const editor = useSlateStatic();

  return (
    <div contentEditable={false} {...props.attributes}>
      <div
        onMouseEnter={() => {
          setShowDelete(true);
        }}
        onMouseLeave={() => setShowDelete(false)}
      >
        {showDelete ? (
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDelete(ReactEditor.findPath(editor, props.element));
            }}
            style={{ position: "absolute", left: 0 }}
            type="default"
            icon={<DeleteOutlined />}
          />
        ) : null}
        <img
          src={props.element.url}
          style={{
            maxHeight: 400,
            maxWidth: "100%",
            display: "block",
            marginLeft: "auto",
            marginRight: "auto",
          }}
          alt=""
        />
      </div>
      {props.children}
    </div>
  );
};

const UploadImg = (props) => {
  const { onDelete, pathParams } = props;

  const editor = useSlateStatic();

  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState();
  const [fileList, setFileList] = useState([]);
  const [showDelete, setShowDelete] = useState(false);

  const handleUpload = async () => {
    setUploading(true);
    setMessage("");
    if (checkFile()) {
      console.log(fileList[0]);
      const formData = new FormData();
      formData.append("fileToUpload", fileList[0]);

      // https://newbrand.s3.eu-west-3.amazonaws.com/shared/LULU_KROY/PL_30_DESTINS_AVENTURIERS/season-1/ep-1/ILLU_BONJOUR_ASTRONAUTE.png
      // TODO: Change here
      const res = await updateStickers(formData, pathParams);
      console.log(res);
      if (res.url) {
        CustomEditor.updateImageAt(
          editor,
          ReactEditor.findPath(editor, props.element),
          res.url
        );
      } else if (res.msg) setMessage(res.msg);
      setUploading(false);
    }
  };

  const checkFile = () => {
    if (fileList.length <= 0) return false;
    const file = fileList[0];
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setMessage("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      setMessage("Image must smaller than 10MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const beforeUpload = (file) => {
    setMessage("");
    setFileList([...fileList, file]);
    return false;
  };

  const onRemove = (file) => {
    setMessage("");
    const index = fileList.indexOf(file);
    const newFileList = fileList.slice();
    newFileList.splice(index, 1);
    setFileList(newFileList);
  };

  return (
    <div
      contentEditable={false}
      onMouseEnter={() => {
        setShowDelete(true);
      }}
      onMouseLeave={() => setShowDelete(false)}
    >
      <Dragger
        disabled={uploading}
        maxCount={1}
        onRemove={onRemove}
        beforeUpload={beforeUpload}
      >
        {showDelete && !uploading ? (
          <Button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDelete(ReactEditor.findPath(editor, props.element));
            }}
            style={{ position: "absolute", left: 0, top: 0 }}
            type="text"
            icon={<DeleteOutlined />}
          />
        ) : null}
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
      </Dragger>
      <Button
        type="primary"
        onClick={handleUpload}
        disabled={fileList.length === 0}
        loading={uploading}
        style={{ marginTop: 16 }}
      >
        {uploading ? "Uploading" : "Start Upload"}
      </Button>
      {message ? <Text type="danger">{message}</Text> : null}
      {props.children}
    </div>
  );
};

const ImageElement = (props) => {
  if (props.element.url) return <DisplayImg {...props} />;
  else return <UploadImg {...props} />;
};

export default ImageElement;
